<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      class="tablaLT1 issues"
      :class="dark_t?'dark':''">
      <template v-slot:item="props">
        <tr>
          <td>
            <v-menu :close-on-click="true" :offset-y="true">
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">more_vert</v-icon>
              </template>
              <v-list>
                <v-list-item @click="view(props.item)">
                  <v-icon>description</v-icon>
                  <span>Ver ficha de inspección</span>
                </v-list-item>
                <v-list-item @click="open_dialog_remove(props.item)" v-if="!disable_edit && myPermissions.includes(45)">
                  <v-icon>delete</v-icon>
                  <span>Eliminar ficha de inspección</span>
                </v-list-item>
                <slot name="edit_list_item" v-bind="{item:props.item}">

                </slot>
              </v-list>
            </v-menu>
          </td>
          <fs1 tag="td" class="textAlignLeft">{{datetimeConversor(props.item.inspection_date)}}</fs1>
          <fs1 tag="td" class="textAlignLeft">{{props.item.description}}</fs1>
          <fs1 tag="td" class="textAlignLeft">{{impact_names[props.item.impact_type]}}</fs1>
          <fs1 tag="td">{{props.item["mfl_"+props.item.impact_type]}}</fs1>
          <fs1 tag="td" class="textAlignLeft">{{likelihood_descriptor[props.item.likelihood]}}</fs1>
          <fs1 tag="td" :class="priority_colors[props.item.priority]" style="color:black">
            <b>{{props.item.priority}}</b> 
          </fs1>
        </tr>
      </template>
      <template v-slot:no-data>
          <v-icon>warning</v-icon>
          Sin Información.
      </template>
    </v-data-table>
    <fs1-dialog :id="`view_finding_inspection`" max_width="1200px" :persistent="false">
      <template v-slot:body>
        <div style="text-align:left;padding:20px">
          <h3 class="dark-orange--text font20 p-flex">Inspección Hallazgo {{selectedItem.finding_code}}, inspección {{datetimeConversor(selectedItem.inspection_date)}}</h3>
          <view_action v-if="selectedItem.id" :selectedItem="selectedItem" :re_inspect="true"/>
        </div>
      </template>
      <template v-slot:footer="{close}">
        <v-btn color="secondary" @click="close">Cerrar</v-btn>
      </template>
    </fs1-dialog>    


    <fs1-dialog :id="`remove_re_inspec-${selectedItem.id}`" :persistent="false" template="warning" max_width="800">
      <template v-slot:body>
        <div class="text_align_left">
          <p>Está a punto de eliminar la inspección realizada el {{selectedItem.inspection_date}}. Esta acción no se puede deshacer. Para continuar, ingrese una justificación de por qué está eliminado este registro.</p>
          <in-text-area v-model="deleted_justification" label="Justificación"/>
        </div>
      </template>
      <template v-slot:footer="{close}">
        <v-btn color="primary" @click="remove" :disabled="removing">Aceptar</v-btn>
        <v-btn color="secondary" @click="close">Cancelar</v-btn>
      </template>
    </fs1-dialog>

    <slot></slot>
  </div>
</template>
<script>
import { likelihood_values, priority_colors } from '@/objects/general.js';
import { getImpactTypes } from '@/objects/mfl_global_risk.js';

export default {
  name:'table_reispec',
  props:['f_id','items','disable_edit','global_risk_standard_version'],
  mixins:[],
  data() {
    return {
      priority_colors,
      selectedItem:{},
      deleted_justification:'',
      removing:false,
      headers:[
        { text: '', sortable: false, value:'actions'},
				{ text: 'Fecha de inspección', value: 'inspection_date', class:'text_align_left'},
				{ text: 'Descripción',  value: 'description', class:'text_align_left'},
				{ text: 'Tipo de impacto', value: 'impact_type', class:'text_align_left'},
        { text: 'MFL', value: 'mfl'},
				{ text: 'Tiempo Estimado para Falla',  value: 'likelihood', class:'text_align_left'},
				{ text: 'Prioridad',  value: 'priority', class:'text_align_left'},
			],
    };
  },
  computed: {
    impact_names(){
      const r = {};
      getImpactTypes(this.global_risk_standard_version).forEach(e => { r[e.id] = e.name; });
      return r;
    },
    likelihood_descriptor(){
      const r = {};
      likelihood_values.forEach(e => r[e.factor] = e.descriptor);
      return r;
    },
  },
  methods:{
		view(item){
      this.open_dialog(`view_finding_inspection`);
      this.requests.get['get_finding_inspection/a'](item.id)
        .then(r=>this.selectedItem=r)
		},
    open_dialog_remove(item){
      this.deleted_justification = '';
      this.selectedItem = item;
      this.open_dialog(`remove_re_inspec-${this.selectedItem.id}`);
    },
    remove(){
      this.removing = true;
      const {deleted_justification} = this;
      this.close_dialog(`remove_re_inspec-${this.selectedItem.id}`);
      //this.$emit('update:items', this.items.filter(item=>item.id != this.selectedItem.id));
      
      this.requests.patch['remove_finding_inspection_date/a']({id:this.selectedItem.id,deleted_justification})
        .then(r=>{
          this.removing = false;
          this.items.splice(this.items.indexOf(this.selectedItem), 1);     
        })
        .catch(e=>{
          this.getError(e);
          this.removing = false;
        })
    },
  }
};
</script>
